module.exports = __webpack_public_path__ + "static/media/warrior.f360e628.png";